export enum RepoStatusEnum {
  NeedCommit = 'NeedCommit',
  NeedPull = 'NeedPull',
  NeedPush = 'NeedPush',
  Ok = 'Ok'
}
